var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("circle",{"cx":"20.5","cy":"20","r":"20","fill":"#EBECF7","key":1}),React.createElement("path",{"d":"M24 17.2h-2.6v-1.7c0-.6.4-.7.7-.7h1.8V12h-2.5c-2.7 0-3.3 2-3.3 3.4v1.8h-1.6V20h1.6v8h3.3v-8h2.2l.3-2.8z","fill":"#6573FF","key":2})]);
}

Facebook.defaultProps = {"width":"41","height":"40","viewBox":"0 0 41 40","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
